import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { Modal, Card, Row, Col, Typography, message } from "antd";
import { setUserData } from '../../../redux/CrmReduxCalls/LocalDataReduxStore';
import { Button } from '../../../components/buttons/buttons';
import { createCurrency, importDemoData } from '../../../Api/Services/CommonApiService';
import { updateUserProfile } from '../../../Api/Services/UserApiService';
import { getCompanyByUser, CompanyUpdate } from '../../../Api/Services/CompanyApiService';

const { Title, Text, Paragraph } = Typography;

const CRMStartModal = ({ open, setOpen }) => {
    const [disable, setDisable] = useState(false)
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const localData = useSelector((state) => state.localRedux);
    const companyProfile = localData.company
    const dispatch = useDispatch();
    const [selected, setSelected] = useState(null);
    const handleSelect = (option) => setSelected(option);
    async function companyDetailsApi2() {
        const CompanyDetails = await getCompanyByUser()
        dispatch(setUserData({
            company: CompanyDetails
        }));
        setOpen(false)
    }
    const fallbackCurrency = {
        decimalOfCurrency: 2,
        currency: "USD",
        currencyName: "US Dollar",
        exchangeRate: 1,
        exchangeRateSetting: "Manual",
        refreshSchedule: "Not Applicable",
        symbol: "$",
    };
    const saveAndNext = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        let hideMessage;
        setDisable(true)
        if (selected === "demo") {
            hideMessage = message.loading("Setting up....", 0);
            const response = await importDemoData()
            if (response.status === 201) {
                const payload = {
                    symbol: "$",
                    currencyName: "US Dollar",
                    defaultCurrency: "USD",
                    decimalOfCurrency: 2,
                    currency: [{
                        "currencyName": "US Dollar",
                        "currency": "USD",
                        "exchangeRateSetting": "Manual",
                        "refreshSchedule": "Not Applicable",
                        "exchangeRate": 1,
                        "symbol": "$",
                    }]
                }
                const data = await createCurrency(payload)
                if (data.status === 201) {
                    dispatch(setUserData({
                        currency: fallbackCurrency,
                        defaultCurrecny: {
                            decimalOfCurrency: 2,
                            ...({
                                "currencyName": "US Dollar",
                                "currency": "USD",
                                "exchangeRateSetting": "Manual",
                                "refreshSchedule": "Not Applicable",
                                "exchangeRate": 1,
                                "symbol": "$",
                            }),
                        }
                    }));
                    const formData =
                    {
                        currency: {
                            currency: "USD",
                            currencyName: "US Dollar"
                        }
                    };
                    await updateUserProfile(formData);
                    const payloads =
                    {
                        loginSetupStatus: "Finish"
                    }
                    const response = await CompanyUpdate(payloads, companyProfile.companyId)
                    if (response.data.statusCode === 200) {
                        companyDetailsApi2()
                        setDisable(false)
                        hideMessage();
                    }
                }
                loadingRef.current = false;
                setDelteClick(false)
            }
            else {
                loadingRef.current = false;
                setDelteClick(false)
                setDisable(false)
                hideMessage();
                message.error("Demo database failed. Try again")
            }
        }
        else if (selected !== "demo") {
            hideMessage = message.loading("Setting up....", 0);
            const payloads =
            {
                loginSetupStatus: "DemoSetup"
            }
            const response = await CompanyUpdate(payloads, companyProfile.companyId)
            if (response.data.statusCode === 200) {
                companyDetailsApi2()
                setDisable(false)
                hideMessage();
                loadingRef.current = false;
                setDelteClick(false)
            }
        }
    }
    return (
        <Modal
            open={open}
            centered
            footer={null}
            closable={false}
            title={null}
            width="fit-content"
            bodyStyle={{
                padding: "40px 60px",
                textAlign: "center",
            }}
            style={{
                maxWidth: "90vw",
            }}
        >
            {/* --- Header Text --- */}
            <div style={{ marginBottom: 40 }}>
                <Title level={3} style={{ color: "#666", marginBottom: 8 }}>
                    How would you like to start using your CRM?
                </Title>
                <Text type="secondary" style={{ color: "#666" }}>
                    You can begin with a clean slate or explore using sample data.
                    <br />
                    Choose the option that best suits you - you can always reset later.
                </Text>
            </div>

            {/* --- Cards --- */}
            <Row gutter={40} justify="center">
                <Col>
                    <Card
                        // hoverable
                        onClick={() => handleSelect("empty")}
                        className={`StartUi ${selected === "empty" ? "selected" : ""}`}
                    >
                        <Title level={4} style={{ color: "#666" }}>Start with an Empty Database</Title>
                        <Paragraph>
                            Set up your CRM from scratch. Ideal if you want to import your own
                            leads, contacts, and deals or connect existing data sources.
                        </Paragraph>
                        <ul style={{ textAlign: "left" }}>
                            <li>• No sample records</li>
                            <li>• Default settings and fields only</li>
                            <li>• Option to import data manually or via CSV</li>
                        </ul>
                    </Card>
                </Col>

                <Col>
                    <Card
                        // hoverable
                        onClick={() => handleSelect("demo")}
                        className={`StartUi ${selected === "demo" ? "selected" : ""}`}
                    >
                        <Title level={4} style={{ color: "#666" }}>Use a Demo Database</Title>
                        <Paragraph>
                            Explore the CRM with preloaded sample data. Perfect for
                            understanding how leads, contacts, deals, and reports work.
                        </Paragraph>
                        <ul style={{ textAlign: "left" }}>
                            <li>• Sample leads, contacts, accounts, and deals</li>
                            <li>• Example automation rules and dashboards</li>
                            <li>• You can clear data anytime</li>
                        </ul>
                    </Card>
                </Col>
            </Row>

            <div className="form_action_button" style={{ marginTop: 20 }}>
                <Button
                    size="small"
                    className="button_colors"
                    disabled={!selected || disable || deleteClick} loading={deleteClick}
                    onClick={() => { saveAndNext() }}
                >
                    {!deleteClick && <FeatherIcon icon="save" />} Save and Next
                </Button>
            </div>
        </Modal>
    );
};
CRMStartModal.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
};
export default CRMStartModal;
